import * as defaultImport from "@splunk/react-icons/ChartSingleValueIcon";
export * from "@splunk/react-icons/ChartSingleValueIcon";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
